/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContentRef } from './ContentRef';
import {
    ContentRefFromJSON,
    ContentRefFromJSONTyped,
    ContentRefToJSON,
    ContentRefToJSONTyped,
} from './ContentRef';

/**
 * Execution result from container
 * @export
 * @interface IntegrationExecutionOutput
 */
export interface IntegrationExecutionOutput {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof IntegrationExecutionOutput
     */
    rawDataOrFromResult?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationExecutionOutput
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationExecutionOutput
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationExecutionOutput
     */
    errorDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationExecutionOutput
     */
    errorPhase?: string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    recordsFetched?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    recordsTransformed?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    recordsLoaded?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    recordsFailed?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    recordsSkipped?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    durationMs?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    fetchDurationMs?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    transformDurationMs?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    loadDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationExecutionOutput
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationExecutionOutput
     */
    endTime?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof IntegrationExecutionOutput
     */
    data?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof IntegrationExecutionOutput
     */
    rawData?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {any}
     * @memberof IntegrationExecutionOutput
     */
    result?: any | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationExecutionOutput
     */
    _function?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationExecutionOutput
     */
    chunked?: boolean;
    /**
     * 
     * @type {Array<ContentRef>}
     * @memberof IntegrationExecutionOutput
     */
    contentRefs?: Array<ContentRef>;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    totalRecordCount?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    totalSizeBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationExecutionOutput
     */
    chunkCount?: number;
}

/**
 * Check if a given object implements the IntegrationExecutionOutput interface.
 */
export function instanceOfIntegrationExecutionOutput(value: object): value is IntegrationExecutionOutput {
    return true;
}

export function IntegrationExecutionOutputFromJSON(json: any): IntegrationExecutionOutput {
    return IntegrationExecutionOutputFromJSONTyped(json, false);
}

export function IntegrationExecutionOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationExecutionOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'rawDataOrFromResult': json['rawDataOrFromResult'] == null ? undefined : json['rawDataOrFromResult'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'errorDetails': json['errorDetails'] == null ? undefined : json['errorDetails'],
        'errorPhase': json['errorPhase'] == null ? undefined : json['errorPhase'],
        'recordsFetched': json['recordsFetched'] == null ? undefined : json['recordsFetched'],
        'recordsTransformed': json['recordsTransformed'] == null ? undefined : json['recordsTransformed'],
        'recordsLoaded': json['recordsLoaded'] == null ? undefined : json['recordsLoaded'],
        'recordsFailed': json['recordsFailed'] == null ? undefined : json['recordsFailed'],
        'recordsSkipped': json['recordsSkipped'] == null ? undefined : json['recordsSkipped'],
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'fetchDurationMs': json['fetchDurationMs'] == null ? undefined : json['fetchDurationMs'],
        'transformDurationMs': json['transformDurationMs'] == null ? undefined : json['transformDurationMs'],
        'loadDurationMs': json['loadDurationMs'] == null ? undefined : json['loadDurationMs'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'data': json['data'] == null ? undefined : json['data'],
        'rawData': json['rawData'] == null ? undefined : json['rawData'],
        'result': json['result'] == null ? undefined : json['result'],
        '_function': json['function'] == null ? undefined : json['function'],
        'chunked': json['chunked'] == null ? undefined : json['chunked'],
        'contentRefs': json['contentRefs'] == null ? undefined : ((json['contentRefs'] as Array<any>).map(ContentRefFromJSON)),
        'totalRecordCount': json['totalRecordCount'] == null ? undefined : json['totalRecordCount'],
        'totalSizeBytes': json['totalSizeBytes'] == null ? undefined : json['totalSizeBytes'],
        'chunkCount': json['chunkCount'] == null ? undefined : json['chunkCount'],
    };
}

export function IntegrationExecutionOutputToJSON(json: any): IntegrationExecutionOutput {
    return IntegrationExecutionOutputToJSONTyped(json, false);
}

export function IntegrationExecutionOutputToJSONTyped(value?: IntegrationExecutionOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rawDataOrFromResult': value['rawDataOrFromResult'],
        'success': value['success'],
        'error': value['error'],
        'errorDetails': value['errorDetails'],
        'errorPhase': value['errorPhase'],
        'recordsFetched': value['recordsFetched'],
        'recordsTransformed': value['recordsTransformed'],
        'recordsLoaded': value['recordsLoaded'],
        'recordsFailed': value['recordsFailed'],
        'recordsSkipped': value['recordsSkipped'],
        'durationMs': value['durationMs'],
        'fetchDurationMs': value['fetchDurationMs'],
        'transformDurationMs': value['transformDurationMs'],
        'loadDurationMs': value['loadDurationMs'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'data': value['data'],
        'rawData': value['rawData'],
        'result': value['result'],
        'function': value['_function'],
        'chunked': value['chunked'],
        'contentRefs': value['contentRefs'] == null ? undefined : ((value['contentRefs'] as Array<any>).map(ContentRefToJSON)),
        'totalRecordCount': value['totalRecordCount'],
        'totalSizeBytes': value['totalSizeBytes'],
        'chunkCount': value['chunkCount'],
    };
}

